import React from 'react';
import { Card, Descriptions, Spin, Tag } from 'antd';

import WinnerInfosDisplay from './WinnerInfosDisplay';
import {
  formatWinnerProgress,
  isSelectionComplete,
} from '../winners';

/**
 * Compact stats block shown above the campaign form (entries, participants, winners).
 */
export default function CampaignStatsCard({ campaign, loading }) {
  if (loading) {
    return (
      <Card title="Campaign Summary" size="small" style={{ marginBottom: 16 }}>
        <div style={{ textAlign: 'center', padding: 16 }}>
          <Spin size="small" />
        </div>
      </Card>
    );
  }

  const totalEntries = campaign && campaign.totalEntries != null ? campaign.totalEntries : 0;
  const totalParticipants = campaign && campaign.totalParticipants != null ? campaign.totalParticipants : 0;
  const complete = campaign ? isSelectionComplete(campaign) : false;

  return (
    <Card title="Campaign Summary" size="small" style={{ marginBottom: 16 }}>
      <Descriptions bordered size="small" column={1}>
        <Descriptions.Item label="Total Entries">{totalEntries}</Descriptions.Item>
        <Descriptions.Item label="Total Participants">{totalParticipants}</Descriptions.Item>
        <Descriptions.Item label="Winners">
          <WinnerInfosDisplay campaign={campaign} showProgress={false} />
        </Descriptions.Item>
        <Descriptions.Item label="Winner progress">
          {campaign ? (
            <Tag color={complete ? 'blue' : 'orange'}>{formatWinnerProgress(campaign)}</Tag>
          ) : (
            '0 / 1'
          )}
        </Descriptions.Item>
        <Descriptions.Item label="Selection complete">
          {complete ? <Tag color="blue">Yes</Tag> : <Tag>No</Tag>}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
}
